<template>
  <div>
    <chanpin  :mingxiMain_type="2" :mingxi_type="3" > </chanpin> 
  </div>
</template>
<script>
import chanpin from '../../tongyong/adminMingxi.vue'
 
export default {

  components: {
    chanpin: chanpin 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
